import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import {
  CheckIdeaExistRequest,
  CheckIdeaExistResponse,
  IdeaCheckFillStrategyRequest,
  IdeaCheckFillStrategyResponse,
  IdeaCreateRequest,
  IdeaDailyPnlResponse,
  IdeaDetailResponse,
  IdeaHistoryResponse,
  IdeaLiquidateRequest,
  IdeaListRequest,
  IdeaListResponse,
  IdeaModifyResponse,
  IdeaUpdateRequest,
} from './idea-api.def.ts'

const interfaceName = 'idea'

export const ideaApi = createApi({
  reducerPath: 'ideaApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['idea-list'],
  endpoints: (build) => ({
    listIdeas: build.query<IdeaListResponse, IdeaListRequest>({
      query: (params) => ({
        url: '/list',
        method: 'GET',
        params: params,
      }),
      providesTags: ['idea-list'],
    }),
    createIdea: build.mutation<IdeaModifyResponse, IdeaCreateRequest>({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['idea-list'],
    }),
    getIdeaDetail: build.query<IdeaDetailResponse, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'GET',
      }),
    }),
    checkIdeaExist: build.query<CheckIdeaExistResponse, CheckIdeaExistRequest>({
      query: (payload) => ({
        url: '/check-exist',
        method: 'POST',
        body: payload,
      }),
    }),
    getIdeaHistory: build.query<IdeaHistoryResponse, string>({
      query: (id) => ({
        url: `/${id}/history`,
        method: 'GET',
      }),
      providesTags: ['idea-list'],
    }),
    getDailyIdeaPnl: build.query<IdeaDailyPnlResponse, string>({
      query: (id) => ({
        url: `/${id}/daily-pnl`,
        method: 'GET',
      }),
      providesTags: ['idea-list'],
    }),
    updateIdea: build.mutation<IdeaModifyResponse, IdeaUpdateRequest>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['idea-list'],
    }),
    liquidateIdea: build.mutation<IdeaModifyResponse, IdeaLiquidateRequest>({
      query: (payload) => ({
        url: `/${payload.id}/liquidate`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['idea-list'],
    }),
    checkFillStrategy: build.query<
      IdeaCheckFillStrategyResponse,
      IdeaCheckFillStrategyRequest
    >({
      query: (payload) => ({
        url: `/${payload.id}/check-fill-strategy`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const {
  useCreateIdeaMutation,
  useGetIdeaDetailQuery,
  useCheckIdeaExistQuery,
  useGetIdeaHistoryQuery,
  useGetDailyIdeaPnlQuery,
  useUpdateIdeaMutation,
  useLiquidateIdeaMutation,
  useCheckFillStrategyQuery,
} = ideaApi
